<div [class]="getElementClasses()" [innerHTML]="markup"></div>
